var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 564.54 563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.76,237.74C319.58,229,326,220,334.06,212.46c24.7-23.29,53.92-35,88-34.74,18.75.16,37.28,1.51,55.35,6.74,41.35,11.95,65.38,40.41,76.83,80.8,8.59,30.29,10.18,61.38,10.24,92.58.11,65.8-.2,131.6,0,197.4,0,6.16-1.71,7.77-7.78,7.72q-50.85-.42-101.7,0c-6,0-7.25-1.79-7.23-7.43q.28-93.91,0-187.83c-.05-15.69-1.05-31.37-5.45-46.63-8.11-28.1-28.22-42.42-57.66-40.86-40.2,2.12-61.1,22-66.23,62.9a234.37,234.37,0,0,0-1.79,29.37c0,60.89-.07,121.78.16,182.67,0,6.08-1.5,7.87-7.7,7.81q-51.22-.45-102.44,0c-5.47,0-7.05-1.44-7.05-7q.23-180.84,0-361.67c0-6,1.94-7.35,7.58-7.31q48.64.36,97.28,0c6,0,7.51,1.88,7.38,7.53C311.54,208.91,311.76,223.33,311.76,237.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126,375.52c0,59.64-.1,119.28.15,178.92,0,6.63-1.63,8.63-8.49,8.56-33.88-.37-67.77-.29-101.65,0C10.59,563,9,561.63,9,556q.24-181.12,0-362.26c0-5,1.21-6.78,6.52-6.74,34.37.22,68.75.29,103.13,0,6.6-.06,7.5,2.5,7.49,8.16Q125.88,285.32,126,375.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.37,67.34a67.91,67.91,0,0,1-67.72,68C30.77,135.32.12,104.79,0,67.92A68,68,0,0,1,67.8,0C104.82,0,135.33,30.44,135.37,67.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInWhite);
export default __webpack_public_path__ + "static/media/linkedIn-white.41e0cbb93d537e2a36ea4b792f11b539.svg";
export { ForwardRef as ReactComponent };